import React from "react";
import { Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useStyles } from "./styles";
import messages from "./messages";
import cn from "classnames";

export type UserActionsProps = {
  onApply: () => void;
  onCancel: () => void;
  valid: boolean;
};

export const UserActions: React.FC<UserActionsProps> = (props) => {
  const classes = useStyles(props);
  return (
    <>
      <div className={classes.buttonBase}>
        <Button
          className={classes.button}
          onClick={props.onApply}
          variant="contained"
          color="primary"
          disabled={!props.valid}
        >
          <FormattedMessage {...messages.save} />
        </Button>
        <Button className={cn(classes.button, classes.btnCancel)} onClick={props.onCancel} variant="contained">
          <FormattedMessage {...messages.cancel} />
        </Button>
      </div>
    </>
  );
};
